// npm packages
import { Container, Row, Col, Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";

// config
import { websites } from "../config/contact";


import "./Footer.css"

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6} className="footer-brand">
            <div className="d-flex gap-2 justify-content-center justify-content-md-start">
              {websites.map((item, i) => (
                <Nav.Item key={i}>
                  <Nav.Link
                    className="square-button"
                    href={item.url}
                    target="_blank"
                  >
                    {item.icon}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </div>
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <p>{t("footer.madeBy")}</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
